module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ma-3"
  }, [_c('v-dialog', {
    attrs: {
      "width": "350",
      "min-height": "500",
      "persist": _vm.isLoadingCambiarRuc
    },
    model: {
      value: (_vm.isChangeCustomer),
      callback: function($$v) {
        _vm.isChangeCustomer = $$v
      },
      expression: "isChangeCustomer"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "px-4 pt-4 d-flex"
  }, [_c('div', {
    staticClass: "font-weight-700 font-size-17"
  }, [_vm._v("Usuarios con RUC:  ")]), (_vm.datosUsuarioSeleccionar) ? _c('div', {
    staticClass: "font-weight-700 font-size-17 primary--text"
  }, [_vm._v(_vm._s(_vm.datosUsuarioSeleccionar.ruc))]) : _vm._e()]), _c('v-radio-group', {
    staticClass: "my-4 mx-4",
    attrs: {
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.usuarioSeleccionado),
      callback: function($$v) {
        _vm.usuarioSeleccionado = $$v
      },
      expression: "usuarioSeleccionado"
    }
  }, _vm._l((_vm.usuariosContrato), function(u, index) {
    return _c('v-radio', {
      key: u.usuario,
      attrs: {
        "value": u.usuario,
        "hide-details": "hide-details"
      },
      scopedSlots: _vm._u([{
        key: "label",
        fn: function() {
          return [_c('div', {
            staticClass: "d-flex fd-column option-user"
          }, [_c('strong', [_vm._v(_vm._s(u.razonSocial))]), _c('span', [_vm._v(_vm._s(u.usuario))])])]
        },
        proxy: true
      }], null, true)
    })
  }), 1), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "block",
      "loading": _vm.isLoadingCambiarRuc
    },
    on: {
      "click": function($event) {
        return _vm.closeDialogIsChangeCustomer()
      }
    }
  }, [_c('small', [_vm._v("Cambiar")])])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "350",
      "min-height": "500",
      "persist": _vm.isLoadingGetAccounts
    },
    model: {
      value: (_vm.isRelationUser),
      callback: function($$v) {
        _vm.isRelationUser = $$v
      },
      expression: "isRelationUser"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "px-4 pt-4 d-flex"
  }, [_c('div', {
    staticClass: "font-weight-700 font-size-17"
  }, [_vm._v("Usuarios relacionados")])]), _c('v-radio-group', {
    staticClass: "my-4 mx-4",
    attrs: {
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.usuarioSeleccionado),
      callback: function($$v) {
        _vm.usuarioSeleccionado = $$v
      },
      expression: "usuarioSeleccionado"
    }
  }, _vm._l((_vm.usuariosRelacionados), function(u, index) {
    return _c('v-radio', {
      key: u.usuario,
      attrs: {
        "value": u.usuario,
        "hide-details": "hide-details"
      },
      on: {
        "click": function($event) {
          return _vm.fetchEquiposOnly(u)
        }
      },
      scopedSlots: _vm._u([{
        key: "label",
        fn: function() {
          return [_c('div', {
            staticClass: "d-flex fd-column option-user"
          }, [_c('strong', [_vm._v(_vm._s(u.razonSocial))]), _c('span', [_vm._v(_vm._s(u.usuario))])])]
        },
        proxy: true
      }], null, true)
    })
  }), 1), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "block",
      "loading": _vm.isLoadingGetAccounts
    },
    on: {
      "click": function($event) {
        return _vm.closeDialogRelationUser()
      }
    }
  }, [_c('small', [_vm._v("Cambiar")])])], 1)], 1)], 1), _c('v-card', {
    staticClass: "mx-auto pa-3 flex fd-column",
    attrs: {
      "elevation": "1"
    }
  }, [_c('div', {
    staticClass: "d-flex ai-center mb-4"
  }, [_c('div', {
    staticClass: "flex fd-column"
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("Tipo de ticket que desea generar")]), _c('v-slide-group', {
    staticClass: "flex-1",
    attrs: {
      "mandatory": "mandatory",
      "show-arrows": ""
    },
    model: {
      value: (_vm.tipoTicket),
      callback: function($$v) {
        _vm.tipoTicket = $$v
      },
      expression: "tipoTicket"
    }
  }, _vm._l((_vm.categoriasTicket), function(n, index) {
    return _c('v-slide-item', {
      key: index,
      staticClass: "animated fadeInLeft faster",
      attrs: {
        "value": n.value
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;
          var toggle = ref.toggle;

          return [_c('v-card', {
            staticClass: "elevation-1 ma-1 d-flex ai-center jc-center text-center",
            attrs: {
              "color": active ? 'primary' : 'secondary primary--text',
              "height": "60",
              "dark": active,
              "width": "140"
            },
            on: {
              "click": toggle
            }
          }, [_c('span', {
            staticClass: "font-size-12 font-weight-600"
          }, [_vm._v(_vm._s(n.name))])])]
        }
      }], null, true)
    })
  }), 1)], 1)]), _c('div', {
    staticClass: "pa-1 d-flex ai-center jc-center"
  }, [_c('div', {
    staticClass: "fd-column flex-1"
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [(_vm.perfilUsuario === 'dispatcher' && !_vm.usuarioSeleccionado) ? _c('div', {
    staticClass: "d-flex mb-3 ai-center jc-center"
  }, [_c('div', {
    staticClass: "flex-1 d-flex justify-end"
  }, [_c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "hide-details",
      "row": "row"
    },
    model: {
      value: (_vm.tipoFiltroBusquedaEquipo),
      callback: function($$v) {
        _vm.tipoFiltroBusquedaEquipo = $$v
      },
      expression: "tipoFiltroBusquedaEquipo"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Buscar una serie",
      "value": "serie",
      "hide-details": "hide-details"
    }
  }), _c('v-radio', {
    attrs: {
      "label": "Listar series por RUC",
      "value": "ruc",
      "hide-details": "hide-details"
    }
  })], 1)], 1)]) : _vm._e(), (_vm.usuarioSeleccionado) ? _c('v-card', {
    staticClass: "mb-4"
  }, [_c('v-list', {
    staticClass: "py-2",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-title', [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v(_vm._s(_vm.datosUsuarioSeleccionar.razonSocial))])]), _c('v-list-item-subtitle', {
    staticClass: "font-size-11"
  }, [_vm._v(_vm._s(_vm.datosUsuarioSeleccionar.usuario))])], 1), _c('v-list-item-action', [_c('div', {
    staticClass: "d-flex"
  }, [(_vm.perfilUsuario === 'dispatcher' && _vm.usuariosContrato.length > 1) ? _c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "color": "info",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.openDialogIsChangeCustomer()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "17"
    }
  }, [_vm._v("list")]), _c('span', [_vm._v("Cambiar")])], 1) : _vm._e(), (_vm.usuarioLogged.esCuentaAdministrador) ? _c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "color": "primary",
      "small": "small",
      "disabled": _vm.tickets.length > 0
    },
    on: {
      "click": function($event) {
        return _vm.openDialogRelationUser()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "17"
    }
  }, [_vm._v("list")]), _c('span', [_vm._v("Cambiar")])], 1) : _vm._e(), (_vm.perfilUsuario === 'dispatcher') ? _c('v-btn', {
    attrs: {
      "color": "error",
      "small": "small",
      "disabled": _vm.tickets.length > 0
    },
    on: {
      "click": function($event) {
        return _vm.limpiarRucUsuario()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "17"
    }
  }, [_vm._v("delete")]), _c('span', [_vm._v("Limpiar")])], 1) : _vm._e()], 1)])], 1)], 1)], 1) : _c('div', {
    staticClass: "d-flex"
  }, [(_vm.tipoFiltroBusquedaEquipo === 'ruc') ? _c('v-text-field', {
    ref: "documento",
    staticClass: "mb-4",
    attrs: {
      "solo": "solo",
      "dense": "dense",
      "type": "number",
      "label": "Ingrese un numero de ruc valido",
      "hide-details": "hide-details"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchEquipos()
      }
    },
    model: {
      value: (_vm.ruc),
      callback: function($$v) {
        _vm.ruc = $$v
      },
      expression: "ruc"
    }
  }) : (_vm.tipoFiltroBusquedaEquipo === 'serie') ? _c('v-text-field', {
    ref: "serie",
    staticClass: "mb-4",
    attrs: {
      "solo": "solo",
      "dense": "dense",
      "type": "text",
      "label": "Ingrese una serie valida",
      "hide-details": "hide-details"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchEquipos()
      }
    },
    model: {
      value: (_vm.serieFiltro),
      callback: function($$v) {
        _vm.serieFiltro = $$v
      },
      expression: "serieFiltro"
    }
  }) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "info",
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchEquipos()
      }
    }
  }, [_vm._v("buscar")])], 1)], 1), (_vm.usuariosContrato.length && _vm.perfilUsuario === 'dispatcher ') ? _c('div', {
    staticClass: "d-flex fd-column mb-4"
  }, [_c('span', {
    staticClass: "font-size-11"
  }, [_vm._v("Cuentas registradas para este cliente")]), (_vm.usuarioSeleccionado.length > 1) ? _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.usuarioSeleccionado),
      callback: function($$v) {
        _vm.usuarioSeleccionado = $$v
      },
      expression: "usuarioSeleccionado"
    }
  }, _vm._l((_vm.usuariosContrato), function(usuario, index) {
    return _c('v-radio', {
      key: index,
      attrs: {
        "label": ((usuario.razonSocial) + " (" + (usuario.usuario) + ")"),
        "value": usuario.usuario,
        "hide-details": "hide-details"
      }
    })
  }), 1) : _vm._e()], 1) : _vm._e(), (_vm.equiposDisponiblesPorRuc.length && _vm.perfilUsuario !== 'dispatcher') ? _c('div', {
    staticClass: "d-flex mb-1"
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("Listado de equipos en contrato")])]) : _vm._e(), (_vm.modelosAgrupadosFiltrados.length && _vm.tipoFiltroBusquedaEquipo === 'ruc') ? _c('div', {
    staticClass: "d-flex"
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.modelosAgrupadosFiltrados,
      "label": "Listado de equipos disponibles",
      "placeholder": "Realiza la busqueda por la serie",
      "dense": "dense",
      "item-value": "serie",
      "item-text": "serie",
      "return-object": "return-object",
      "hide-details": "hide-details",
      "solo": "solo"
    },
    on: {
      "change": _vm.agregarNuevoTicket
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('v-list-item-content', [_c('v-list-item-title', [_c('div', {
          staticClass: "d-flex"
        }, [_c('span', {
          staticClass: "font-weight-700"
        }, [_vm._v(_vm._s(("#" + (data.item.numeroContrato))) + " -  ")]), _c('span', {
          staticClass: "font-weight-700 primary--text"
        }, [_vm._v(_vm._s(data.item.serie))])])]), _c('v-list-item-subtitle', [_c('span', {
          staticClass: "font-size-11 info--text"
        }, [_vm._v(_vm._s(data.item.descripcionArticulo))])]), (data.item.ubicacion) ? _c('v-list-item-subtitle', [_c('span', {
          staticClass: "font-size-11 grey--text"
        }, [_vm._v(_vm._s(data.item.ubicacion || '--'))])]) : _vm._e()], 1)]
      }
    }], null, false, 1765659753)
  })], 1) : _vm._e()])]), _c('div', {
    staticClass: "box-new-ticket pa-1"
  }, [_c('div', {
    staticClass: "elevation-0 py-0 mt-2 px-0"
  }, _vm._l((_vm.tickets), function(t, index) {
    return _c('v-list-group', {
      key: index,
      staticClass: "border-bottom-2px",
      class: {
        'pb-3 background': t.active
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function() {
          return [_c('v-list-item-content', {
            staticClass: "px-0 py-0"
          }, [_c('v-list-item-title', [_c('v-list', {
            staticClass: "py-2",
            attrs: {
              "dense": "dense",
              "color": t.active ? 'background' : ''
            }
          }, [_c('v-list-item', [_c('v-list-item-avatar', {
            attrs: {
              "color": "primary"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "white"
            }
          }, [_vm._v("print")])], 1), _c('v-list-item-content', {
            staticClass: "py-0"
          }, [_c('v-list-item-title', [_c('span', {
            staticClass: "font-weight-700"
          }, [_vm._v(_vm._s(("#" + (t.numeroContrato))) + " -  ")]), _c('span', {
            staticClass: "font-weight-700"
          }, [_vm._v(_vm._s(t.modelo) + " -  ")]), _c('span', {
            staticClass: "font-weight-700 primary--text"
          }, [_vm._v(_vm._s(t.serie))])]), _c('v-list-item-subtitle', {
            staticClass: "info--text font-weight-700"
          }, [_vm._v(_vm._s(t.descripcion))]), (!t.active) ? _c('v-list-item-subtitle', {
            staticClass: "font-weight-700"
          }, [_vm._v(_vm._s(t.direccion) + " - (" + _vm._s(t.distrito) + " - " + _vm._s(t.provincia) + " - " + _vm._s(t.departamento) + ")")]) : _vm._e()], 1), _c('v-list-item-action', [_c('v-btn', {
            attrs: {
              "color": "error",
              "small": "small"
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.eliminarItemSerie(index)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "size": "17"
            }
          }, [_vm._v("delete")]), _c('span', [_vm._v("Eliminar")])], 1)], 1)], 1)], 1)], 1)], 1)]
        },
        proxy: true
      }], null, true),
      model: {
        value: (t.active),
        callback: function($$v) {
          _vm.$set(t, "active", $$v)
        },
        expression: "t.active"
      }
    }, [_c('v-list-item', {
      key: index,
      staticClass: "px-4"
    }, [_c('v-list-item-content', {
      staticClass: "py-0"
    }, [(_vm.tipoTicket === 'solicitud de insumo' && t.clasificacion) ? _c('div', {
      staticClass: "mt-0"
    }, [_c('small', {
      staticClass: "font-size-11"
    }, [_vm._v("Insumos disponibles para el equipo " + _vm._s(t.clasificacion))]), (t.incluyePapel && t.clasificacion === 'multifuncional') ? _c('v-radio-group', {
      staticClass: "mb-2",
      attrs: {
        "row": "",
        "hide-details": "hide-details"
      },
      on: {
        "change": function (valor) { return _vm.recalcularInsumos(t); }
      },
      model: {
        value: (t.grupoPedidoInsumo),
        callback: function($$v) {
          _vm.$set(t, "grupoPedidoInsumo", $$v)
        },
        expression: "t.grupoPedidoInsumo"
      }
    }, [_c('v-radio', {
      attrs: {
        "label": "Consumible",
        "value": "consumible"
      }
    }), _c('v-radio', {
      attrs: {
        "label": "Papel",
        "value": "papel"
      }
    })], 1) : _vm._e(), (t.grupoPedidoInsumo === 'consumible') ? _c('div', {
      staticClass: "d-flex fd-column my-2"
    }, _vm._l((t.insumo), function(item, i) {
      return _c('div', {
        staticClass: "d-flex ai-center"
      }, [_c('v-checkbox', {
        staticClass: "ma-0",
        attrs: {
          "name": item.code,
          "id": item.code,
          "color": "primary",
          "hide-details": "hide-details"
        },
        model: {
          value: (item.active),
          callback: function($$v) {
            _vm.$set(item, "active", $$v)
          },
          expression: "item.active"
        }
      }), _c('label', {
        staticClass: "font-size-11",
        class: {
          '!primary--text font-weight-700': item.active
        },
        attrs: {
          "for": item.code
        }
      }, [_vm._v(_vm._s(item.name))])], 1)
    }), 0) : _vm._e(), (t.grupoPedidoInsumo === 'papel') ? _c('div', {
      staticClass: "d-flex fd-column mb-2"
    }, [_c('small', {
      staticClass: "font-size-11 primary--text"
    }, [_vm._v("Se solicitará papel para el equipo seleccionado")])]) : _vm._e()], 1) : _vm._e(), (_vm.tipoTicket === 'incidencia con equipo') ? _c('div', {
      staticClass: "mt-0"
    }, [_c('span', {
      staticClass: "font-size-11"
    }, [_vm._v(" ¿Cual es la falla que presenta ese equipo?")]), _c('v-select', {
      staticClass: "mt-1",
      attrs: {
        "loading": _vm.isGettingFallas,
        "dense": "dense",
        "hide-details": "hide-details",
        "item-text": "descripcionFallaGeneral",
        "item-value": "codigoFallaGeneral",
        "return-object": "return-object",
        "items": _vm.fallas,
        "placeholder": ("Listado de fallas para la serie " + (t.serie)),
        "solo": "solo"
      },
      model: {
        value: (t.falla),
        callback: function($$v) {
          _vm.$set(t, "falla", $$v)
        },
        expression: "t.falla"
      }
    })], 1) : _vm._e(), (_vm.tipoTicket === 'solicitud de insumo' && t.serie) ? _c('div', {
      staticClass: "mt-0"
    }, [_c('v-text-field', {
      attrs: {
        "dense": "dense",
        "hide-details": "hide-details",
        "placeholder": "Ingresa una dirección valida",
        "solo": "solo"
      },
      model: {
        value: (t.direccion),
        callback: function($$v) {
          _vm.$set(t, "direccion", $$v)
        },
        expression: "t.direccion"
      }
    })], 1) : _vm._e(), (_vm.tipoTicket === 'solicitud de insumo') ? _c('div', {
      staticClass: "mt-0"
    }, [_c('small', {
      staticClass: "font-size-11"
    }, [_vm._v(" Departamento")]), _c('v-autocomplete', {
      staticClass: "mt-1",
      attrs: {
        "items": t.departamentos,
        "dense": "",
        "label": "Departamento",
        "hide-details": "hide-details",
        "solo": "solo"
      },
      on: {
        "change": function($event) {
          return _vm.rellenarInformacion('departamento', index)
        }
      },
      model: {
        value: (t.departamento),
        callback: function($$v) {
          _vm.$set(t, "departamento", $$v)
        },
        expression: "t.departamento"
      }
    })], 1) : _vm._e(), (_vm.tipoTicket === 'solicitud de insumo') ? _c('div', {
      staticClass: "mt-0"
    }, [_c('small', {
      staticClass: "font-size-11"
    }, [_vm._v(" Provicia")]), _c('v-autocomplete', {
      staticClass: "mt-1",
      attrs: {
        "items": t.provincias,
        "dense": "",
        "label": "Provincia",
        "hide-details": "hide-details",
        "solo": "solo"
      },
      on: {
        "change": function($event) {
          return _vm.rellenarInformacion('provincia', index)
        }
      },
      model: {
        value: (t.provincia),
        callback: function($$v) {
          _vm.$set(t, "provincia", $$v)
        },
        expression: "t.provincia"
      }
    })], 1) : _vm._e(), (_vm.tipoTicket === 'solicitud de insumo') ? _c('div', {
      staticClass: "mt-0"
    }, [_c('small', {
      staticClass: "font-size-11"
    }, [_vm._v(" Distrito")]), _c('v-autocomplete', {
      staticClass: "mt-1",
      attrs: {
        "items": t.distritos,
        "dense": "",
        "label": "Distrito",
        "hide-details": "hide-details",
        "solo": "solo"
      },
      on: {
        "change": function($event) {
          return _vm.rellenarInformacion('distrito', index)
        }
      },
      model: {
        value: (t.distrito),
        callback: function($$v) {
          _vm.$set(t, "distrito", $$v)
        },
        expression: "t.distrito"
      }
    })], 1) : _vm._e(), (_vm.tipoTicket === 'solicitud de insumo' && t.serie) ? _c('div', {
      staticClass: "mt-0"
    }, [_c('small', {
      staticClass: "font-size-11"
    }, [_vm._v(" Nombre completo de la persona de contacto")]), _c('v-text-field', {
      staticClass: "mt-1",
      attrs: {
        "dense": "dense",
        "hide-details": "hide-details",
        "placeholder": "Ingresa el nombre del contacto",
        "solo": "solo"
      },
      model: {
        value: (t.nombreContacto),
        callback: function($$v) {
          _vm.$set(t, "nombreContacto", $$v)
        },
        expression: "t.nombreContacto"
      }
    })], 1) : _vm._e(), (_vm.tipoTicket === 'solicitud de insumo' && t.serie) ? _c('div', {
      staticClass: "mt-0"
    }, [_c('small', {
      staticClass: "font-size-11"
    }, [_vm._v(" Numero de telefono celular de la persona de contacto")]), _c('v-text-field', {
      staticClass: "mt-1",
      attrs: {
        "dense": "dense",
        "hide-details": "hide-details",
        "placeholder": "Ingresa el numero de telefono  del contacto",
        "solo": "solo",
        "type": "number"
      },
      model: {
        value: (t.numeroTelefono),
        callback: function($$v) {
          _vm.$set(t, "numeroTelefono", $$v)
        },
        expression: "t.numeroTelefono"
      }
    })], 1) : _vm._e(), (_vm.tipoTicket === 'solicitud de insumo' && t.clasificacion === 'multifuncional') ? _c('div', {
      staticClass: "mt-0"
    }, [_c('small', {
      staticClass: "font-size-11"
    }, [_vm._v(" Contador actual del equipo (opcional)")]), _c('v-text-field', {
      staticClass: "mt-1",
      attrs: {
        "dense": "dense",
        "hide-details": "hide-details",
        "placeholder": "Ingresa el contador actual",
        "solo": "solo",
        "type": "number"
      },
      model: {
        value: (t.contadorActual),
        callback: function($$v) {
          _vm.$set(t, "contadorActual", $$v)
        },
        expression: "t.contadorActual"
      }
    })], 1) : _vm._e(), (t.tipo === 'incidencia con equipo') ? _c('v-alert', {
      staticClass: "my-4",
      attrs: {
        "icon": "warning",
        "type": "warning",
        "text": "text"
      }
    }, [_c('div', {
      staticClass: "d-flex fd-column"
    }, [_c('span', {
      staticClass: "font-size-14 font-weight-700"
    }, [_vm._v("Explicanos un poco más de la falla de tu equipo")]), _c('small', {
      staticClass: "font-size-11"
    }, [_vm._v("Ejemplos")]), _c('small', {
      staticClass: "font-size-11"
    }, [_vm._v("- La parte superior izquierda de la hoja sale manchada de rojo")]), _c('small', {
      staticClass: "font-size-11"
    }, [_vm._v("- Si el equipo mostrara un código de error, por favor ingreselo aquí")])])]) : _c('v-alert', {
      staticClass: "my-4",
      attrs: {
        "icon": "info",
        "type": "info",
        "text": "text"
      }
    }, [_c('div', {
      staticClass: "d-flex fd-column"
    }, [_c('span', {
      staticClass: "font-size-14 font-weight-700"
    }, [_vm._v("Alguna observación adicional")]), _c('small', {
      staticClass: "font-size-11"
    }, [_vm._v("Ejemplos")]), _c('small', {
      staticClass: "font-size-11"
    }, [_vm._v("- Acercarse de 2pm a 6pm que se encuentra el encargado")]), _c('small', {
      staticClass: "font-size-11"
    }, [_vm._v("- Solo enviar el color negro y amarillo")])])]), _c('div', [_c('small', {
      staticClass: "font-size-11"
    }, [_vm._v(" Ingrese un comentario adicional (opcional)")]), _c('v-textarea', {
      attrs: {
        "placeholder": "Comentario adicional  (opcional)",
        "solo": "solo",
        "dense": "dense",
        "rows": "4"
      },
      model: {
        value: (t.comentarioGeneral),
        callback: function($$v) {
          _vm.$set(t, "comentarioGeneral", $$v)
        },
        expression: "t.comentarioGeneral"
      }
    })], 1)], 1)], 1)], 1)
  }), 1)]), _c('v-divider'), _c('div', {
    staticClass: "d-flex pa-3"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "disabled": !_vm.tickets.length,
      "color": "success",
      "small": !_vm.isMovil,
      "block": _vm.isMovil,
      "loading": _vm.isLoadingProceso
    },
    on: {
      "click": function($event) {
        return _vm.procesoGenerarTickets()
      }
    }
  }, [_vm._v("Generar ticket")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02efff14","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/New_Ticket_Contrato_View.vue
// module id = 474
// module chunks = 1